<template>
    <div>
        <div class="form-group row mb-0">
            <label class="form-control-label col-4" :for="'attendee_' + attendeeIndex + '_name'">
                {{ subTitle }} {{ $t('ceremony.name_email') }}{{ isRequired ? '*' : '' }}
            </label>

            <div class="col-8 d-flex align-items-center">
                <input
                    :id="'attendee_' + attendeeIndex + '_name'"
                    :disabled="disabled"
                    type="text"
                    class="form-control form-control-sm mr-1"
                    v-model="localValue.name"
                    @change="change"
                    @input="input"
                    @keydown="markDirty('name')"
                    placeholder="Jan Janssen"
                />

                <input
                    :id="'attendee_' + attendeeIndex + '_email'"
                    :disabled="disabled"
                    type="email"
                    class="form-control form-control-sm ml-1"
                    v-model="localValue.email"
                    @change="change"
                    @input="input"
                    @keydown="markDirty('email')"
                    placeholder="jan@janssen.nl"
                />
            </div>

            <div class="col-8 offset-4">
                <form-errors :errors="errors" :field="'attendees.' + attendeeIndex + '.name'" />
                <form-errors :errors="errors" :field="'attendees.' + attendeeIndex + '.email'" />
            </div>
        </div>

        <div class="form-group row" v-if="canSendInvite">
            <div class="col-8 offset-4">
                <div class="custom-control custom-checkbox">
                    <input
                        type="checkbox"
                        class="custom-control-input"
                        :id="'send_invite_' + attendeeIndex"
                        style="cursor: pointer"
                        v-model="localValue.send_invite"
                        @change="input(); change();"
                    />
                    <label class="custom-control-label" :for="'send_invite_' + attendeeIndex">
                        {{ subTitle }} {{ $t('ceremony.send_invite') }}
                        <sup>
                            <icon name="question-circle" v-tooltip="$t('ceremony.send_invite_tooltip')" />
                        </sup>
                    </label>
                </div>

                <form-errors :errors="errors" :field="'attendees.' + attendeeIndex + '.send_invite'" />
            </div>
        </div>
    </div>
</template>
<script setup>
    import FormErrors from '../components/FormErrors.vue';
    import { ref, watch } from 'vue';

    const emit = defineEmits(['input', 'change']);

    const props = defineProps({
        subTitle: {
            type: String,
            required: true,
        },

        attendeeIndex: {
            type: Number,
            required: true,
        },

        value: {
            type: Object,
            required: true,
        },

        isRequired: {
            type: Boolean,
            default: false,
        },

        disabled: {
            type: Boolean,
            default: false,
        },

        errors: {
            type: [Object, null],
            default: null,
        },

        canSendInvite: {
            type: Boolean,
            default: false,
        },
    });

    const localValue = ref({
        ...props.value,
    });

    watch(() => props.value, () => {
        localValue.value = {
            ...props.value,
        };
    }, {
        deep: true,
    });

    function markDirty(field) {
        localValue.value[field + 'Dirty'] = true;
    }

    function input() {
        emit('input', localValue.value);
    }

    function change() {
        emit('change', localValue.value);
    }
</script>
